import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function BingoGameInfo() {
  return (
    <div className=" p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Bingo" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Bingo</h1>
      <img
        src="/thumbnails/Bingo.png"
        alt="Bingo game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Bingo</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Bingo is a popular game of chance in which players mark off numbers on cards as the numbers are drawn randomly by a caller. The game is played with a set of cards containing a grid of numbers, and the goal is to complete a specific pattern, such as a line or full house, to win prizes. Bingo is known for its social aspect and excitement as players await the next number.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Players mark off numbers on their cards as they are called out by the caller.</li>
          <li>The goal is to complete a specific pattern, such as a line or full house, to win prizes.</li>
          <li>The game continues until a player completes the required pattern and calls out "Bingo!"</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">History</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Bingo has a long history, with roots tracing back to a lottery game called "Beano" played in the United States in the early 20th century. The game evolved into the modern version of Bingo, which became popular in the 1920s and 1930s. The name "Bingo" is said to have originated from a player accidentally shouting "Bingo!" instead of "Beano."
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Strategy Tips</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Pay attention to the numbers being called and mark them off quickly.</li>
          <li>Use all the luck you can muster!</li>
        </ul>
      </section>
        <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Bingo</h2>
        <p className="text-gray-700 dark:text-gray-300">
          You can play Bingo for free with friends or other players right here on Game for a Laugh! No download or registration required.
        </p>
        <PlayGameLink game="Bingo" />
      </section>
    </div>
  );
}
